module.exports = __webpack_public_path__ + "static/media/StrengthsIdentification.0bab2023.mp3";